import React from "react";
import { UserRound, ClipboardCheck, Hammer } from "lucide-react";
import "./ProcessSection.css";

/**
 * ProcessSection
 * Three service pillars with icons: Consulting, Renovation, Installation
 * Self-contained styles for easy drop-in. No external CSS required.
 */
const items = [
  {
    key: "consulting",
    title: "Project Consultation",
    text:
      "Let's discuss your vision and explore practical solutions. I’ll help map out your project with expert insights and a clear action plan tailored to your needs.",
    svg: (
      <UserRound size={42} strokeWidth={2.2} color="#0f172a" />
    )
  },
  {
    key: "planning",
    title: "Planning & Solutions",
    text:
      "I work with you to plan the best approach for your project, offering tailored solutions to fit your needs.",
    svg: (
      <ClipboardCheck size={42} strokeWidth={2.2} color="#0f172a" />
    )
  },
  {
    key: "execution",
    title: "Hands-On Execution",
    text:
      "Turning plans into action, I deliver quality craftsmanship and hands-on work to bring your project to life.",
    svg: (
      <Hammer size={42} strokeWidth={2.2} color="#0f172a" />
    )
  }
];

export default function ProcessSection() {
  return (
    <section className="process">
      <div className="container">
        {items.map((item) => (
          <article key={item.key} className="card" aria-label={item.title}>
            <div className="iconWrap">{item.svg}</div>
            <h3 className="title">{item.title}</h3>
            <p className="text">{item.text}</p>
          </article>
        ))}
      </div>
    </section>
  );
}